import { render, staticRenderFns } from "./ReportPalette.vue?vue&type=template&id=1dfea7b6&scoped=true&"
import script from "./ReportPalette.vue?vue&type=script&lang=js&"
export * from "./ReportPalette.vue?vue&type=script&lang=js&"
import style0 from "./ReportPalette.vue?vue&type=style&index=0&id=1dfea7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfea7b6",
  null
  
)

export default component.exports